export const swedish = {
  translations: {
    'Select Your Invoice Language': 'Välj ditt fakturaspråk',
    'Preliminary Invoice': 'Preliminär Faktura',
    Preliminaryinvoice: 'Preliminärfaktura',
    'Customer no': 'Kund nr',
    'Invoice No': 'Faktura nr',
    'Not created yet': 'Inte skapad än',
    'Your reference': 'Er referens',
    'Your VAT number': 'Ert VAT-nummer',
    'Our reference': 'Vår referens',
    'Payment terms': 'Betalningsvillkor',
    Days: 'Dagar',
    'Due date': 'Förfallodatum',
    'Invoice date': 'Fakturadatum',
    'Article No.': 'Artnr.',
    Name: 'Benämning',
    Quantity: 'Antal',
    Unit: 'Enhet',
    'Price per unit': 'Pris per enhet',
    Total: 'Totalt',
    'Fixed Price': 'Fast pris',
    'Excluding VAT': 'Exklusive moms',
    'VAT %': 'Moms %',
    VAT: 'Moms',
    'Round-off': 'Öresutj',
    Currency: 'Valuta',
    'ROT / RUT': 'ROT / RUT',
    'To pay': 'Att betala',
    'PLEASE NOTE THAT THIS IS A PRELIMINARY INVOICE': 'OBSERVERA ATT DETTA ÄR PRELIMINÄRFAKTURA',
    'Org. Number': 'Org. Antal',
    'Vat Number': 'Momsnummer',
    'Total working hours:': 'Totalt arbetade timmar:',
    'Invoice': 'Faktura',
    'Payment Per Hour': 'Betalning per timme',
    'Payment Per Day': 'Betalning per dag',
    'Payment Per Week': 'Betalning per vecka',
    'Payment Per Month': 'Betalning per månad',
    'Payment As Agreed': 'Betalning enligt överenskommelse',
    "Amount inc. VAT": "Belopp inkl. moms",
    "Something went wrong while saving invoice, this invoice has been cancelled. Please try again.": "Något gick fel när fakturan sparades, den här fakturan har annullerats. Försök igen.",
    "Amount after taxes": "Belopp efter skatt",
    "Please note: As of May 27, 2025, we are using a new Swedish bankgiro number, managed by PS Betalningsservice. All IBAN payments should be paid to Invozios account at Revolut.": "Observera: Från och med den 27 maj 2025 använder vi ett nytt svenskt bankgironummer, som hanteras av PS Betalningsservice. Alla IBAN-betalningar ska betalas till Invozios konto hos Revolut.",
    "You have received an invoice from Invozio in collaboration with PS Betalningsservice, which manages the invoice's bankgiro, and TP Finance, which handles salary payments to the affiliated freelancer.": "Du har fått en faktura från Invozio i samarbete med PS Betalningsservice, som hanterar fakturans bankgiro, och TP Finance, som hanterar löneutbetalningar till den anslutna frilansaren.",
    "The freelancer's name is listed as the reference on the invoice. If you have any questions regarding the invoice, pricing, or the work performed, please contact the freelancer directly. They have also received a copy of the invoice.": "Frilansarens namn är listat som referens på fakturan. Om du har några frågor angående fakturan, prissättning eller det utförda arbetet, vänligen kontakta frilansaren direkt. De har också fått en kopia av fakturan.",
    "If you have any questions, feel free to contact us:": "Om du har några frågor, tveka inte att kontakta oss:",
    "Your continued trust in Invozio inspires us to serve you better.": "Ditt fortsatta förtroende för Invozio inspirerar oss att tjäna dig bättre.",
    "Here is your credit invoice from Invozio.": "Här kommer din kreditfaktura från Invozio.",
    "This invoice has been issued to adjust a previous charge and should be used as supporting documentation in your accounting.": "Denna faktura har tagits fram för att korrigera en tidigare debitering och fungerar som underlag i din bokföring.",
    "If you have any questions or concerns regarding this credit invoice, previous invoices, or anything else related to our services, you are always welcome to reach out to us.": "Om du har några frågor eller funderingar kring denna kreditfaktura, tidigare fakturor eller något annat som rör våra tjänster, är du alltid varmt välkommen att kontakta oss.",
    "Please see the copy of the invoice, the invoice has been sent out as an E-invoice to your customer.": "Vänligen se kopian av fakturan, fakturan har skickats ut som en E-faktura till din kund.",
  },
};
